import Cookies from "js-cookie";

// export const BASE_URL = "http://192.168.100.19:5000/graphql";
export const BASE_URL = "https://vitalax-api.herokuapp.com/graphql";
// export const BASE_URL = "https://gwcl-pheonix-api.herokuapp.com/graphql";
// export const BASE_URL = "http://192.168.100.2:5000/graphql";

class Auth {
  getCipher() {
    return Cookies.get("gwcl-customer-web-cipher");
  }

  setCipher(token) {
    Cookies.set("gwcl-customer-web-cipher", token);
  }

  clearCipher() {
    Cookies.remove("gwcl-customer-web-cipher");
  }
}

export default new Auth();
